import { useState } from 'react';
import {
  DEFAULT_EDGE_SNAPPING_ENABLED,
  DEFAULT_GRID_SIZE,
  DEFAULT_GRID_SNAPPING_ENABLED,
  DEFAULT_SNAP_THRESHOLD,
  DEFAULT_SNAPPING_ENABLED,
} from '../constants';

interface UseUIStateReturn {
  isShiftPressed: boolean;
  setIsShiftPressed: React.Dispatch<React.SetStateAction<boolean>>;
  isGridVisible: boolean;
  setIsGridVisible: React.Dispatch<React.SetStateAction<boolean>>;
  currentRenderType: 'rendered' | 'lined';
  setCurrentRenderType: React.Dispatch<
    React.SetStateAction<'rendered' | 'lined'>
  >;
  isCameraControlsEnabled: boolean;
  setIsCameraControlsEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  showCameraControlsModal: boolean;
  setShowCameraControlsModal: React.Dispatch<React.SetStateAction<boolean>>;
  dontShowAgain: boolean;
  setDontShowAgain: React.Dispatch<React.SetStateAction<boolean>>;
  cubeSize: { width: number; height: number; depth: number };
  setCubeSize: React.Dispatch<
    React.SetStateAction<{ width: number; height: number; depth: number }>
  >;
  sphereRadius: number;
  setSphereRadius: React.Dispatch<React.SetStateAction<number>>;
  isSnappingEnabled: boolean;
  setIsSnappingEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  isGridSnappingEnabled: boolean;
  setIsGridSnappingEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  isEdgeSnappingEnabled: boolean;
  setIsEdgeSnappingEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  gridSize: number;
  setGridSize: React.Dispatch<React.SetStateAction<number>>;
  snapThreshold: number;
  setSnapThreshold: React.Dispatch<React.SetStateAction<number>>;
  isDebugMode: boolean;
  setIsDebugMode: React.Dispatch<React.SetStateAction<boolean>>;
}

export const useUIState = (): UseUIStateReturn => {
  const [isShiftPressed, setIsShiftPressed] = useState<boolean>(false);
  const [isGridVisible, setIsGridVisible] = useState<boolean>(true);
  const [currentRenderType, setCurrentRenderType] = useState<
    'rendered' | 'lined'
  >('rendered');
  const [isCameraControlsEnabled, setIsCameraControlsEnabled] =
    useState<boolean>(false);
  const [showCameraControlsModal, setShowCameraControlsModal] =
    useState<boolean>(false);
  const [dontShowAgain, setDontShowAgain] = useState<boolean>(false);
  const [cubeSize, setCubeSize] = useState<{
    width: number;
    height: number;
    depth: number;
  }>({
    width: 0.2,
    height: 0.2,
    depth: 0.2,
  });
  const [sphereRadius, setSphereRadius] = useState<number>(0.1);
  const [isSnappingEnabled, setIsSnappingEnabled] = useState(
    DEFAULT_SNAPPING_ENABLED
  );
  const [isGridSnappingEnabled, setIsGridSnappingEnabled] = useState(
    DEFAULT_GRID_SNAPPING_ENABLED
  );
  const [isEdgeSnappingEnabled, setIsEdgeSnappingEnabled] = useState(
    DEFAULT_EDGE_SNAPPING_ENABLED
  );
  const [gridSize, setGridSize] = useState(DEFAULT_GRID_SIZE);
  const [snapThreshold, setSnapThreshold] = useState(DEFAULT_SNAP_THRESHOLD);
  const [isDebugMode, setIsDebugMode] = useState(false);

  return {
    isShiftPressed,
    setIsShiftPressed,
    isGridVisible,
    setIsGridVisible,
    currentRenderType,
    setCurrentRenderType,
    isCameraControlsEnabled,
    setIsCameraControlsEnabled,
    showCameraControlsModal,
    setShowCameraControlsModal,
    dontShowAgain,
    setDontShowAgain,
    cubeSize,
    setCubeSize,
    sphereRadius,
    setSphereRadius,
    isSnappingEnabled,
    setIsSnappingEnabled,
    isGridSnappingEnabled,
    setIsGridSnappingEnabled,
    isEdgeSnappingEnabled,
    setIsEdgeSnappingEnabled,
    gridSize,
    setGridSize,
    snapThreshold,
    setSnapThreshold,
    isDebugMode,
    setIsDebugMode,
  };
};
